/**
 * GLM2 Wishlist
 * Oturum açmamış: Cookie (30 gün)
 * Oturum açmış: Customer metafield + Cookie sync
 */
(function() {
  'use strict';

  var COOKIE_NAME = 'glame_wishlist';
  var COOKIE_DAYS = 30;
  var isLoggedIn = document.body.classList.contains('customer-logged-in');
  var wishlist = [];

  /* ── Cookie helpers ── */
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
      try { return JSON.parse(decodeURIComponent(match[2])); }
      catch(e) { return []; }
    }
    return [];
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + ';' + expires + ';path=/;SameSite=Lax';
  }

  /* ── Customer metafield via cart attributes ── */
  function saveToMeta(list) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { wishlist: JSON.stringify(list) } })
    }).catch(function() {});
  }

  function loadFromMeta(callback) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var attr = cart.attributes && cart.attributes.wishlist;
        if (attr) {
          try { callback(JSON.parse(attr)); return; } catch(e) {}
        }
        callback([]);
      })
      .catch(function() { callback([]); });
  }

  /* ── Core ── */
  function init() {
    var cookieList = getCookie(COOKIE_NAME);

    if (isLoggedIn) {
      loadFromMeta(function(metaList) {
        // Merge cookie + meta (deduplicate)
        var merged = metaList.slice();
        cookieList.forEach(function(id) {
          if (merged.indexOf(id) === -1) merged.push(id);
        });
        wishlist = merged;
        save();
        updateUI();
      });
    } else {
      wishlist = cookieList;
      updateUI();
    }
  }

  function save() {
    setCookie(COOKIE_NAME, wishlist, COOKIE_DAYS);
    if (isLoggedIn) saveToMeta(wishlist);
  }

  function toggle(productId) {
    var id = String(productId);
    var idx = wishlist.indexOf(id);
    var added = idx === -1;
    if (added) { wishlist.push(id); } else { wishlist.splice(idx, 1); }
    save();
    updateUI();
    showToast(added ? 'Favorilere eklendi ♥' : 'Favorilerden çıkarıldı');
    return added;
  }

  function updateUI() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      var pid = btn.dataset.wishlistToggle;
      var active = wishlist.indexOf(String(pid)) > -1;
      btn.classList.toggle('pc-wl--active', active);
      var svg = btn.querySelector('svg');
      if (svg) {
        svg.style.fill = active ? 'var(--g)' : 'none';
        svg.style.stroke = active ? 'var(--g)' : '';
      }
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = wishlist.length;
      el.style.display = wishlist.length > 0 ? 'flex' : 'none';
    });

    /* Favoriler sayfası listeyi buradan dinliyor: oturum açıkken liste sepet
       attribute'undan sonradan tamamlandığı için olay tekrar yayınlanır. */
    document.dispatchEvent(new CustomEvent('glame:wishlist', {
      detail: { list: wishlist.slice() }
    }));
  }

  function showToast(msg) {
    var old = document.querySelector('.wl-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'wl-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function() { t.classList.add('wl-toast--show'); });
    setTimeout(function() {
      t.classList.remove('wl-toast--show');
      setTimeout(function() { t.remove(); }, 300);
    }, 2000);
  }

  /* ── Events ── */
  document.addEventListener('DOMContentLoaded', function() {
    init();
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        toggle(btn.dataset.wishlistToggle);
        btn.style.transform = 'scale(1.3)';
        setTimeout(function() { btn.style.transform = ''; }, 200);
      }
    });
  });

  window.GlameWishlist = {
    get: function() { return wishlist.slice(); },
    toggle: toggle,
    isIn: function(id) { return wishlist.indexOf(String(id)) > -1; },
    count: function() { return wishlist.length; }
  };
})();
